import React, { Component } from 'react';
import { Card, Container, Form, Button, Col, Row, Alert } from 'react-bootstrap';
import classes from './resetPassword.module.css';
import ResetPasswordSuccess from './ResetPasswordSuccess/resetPasswordSuccess';
import {connect} from 'react-redux';
import * as actionTypes from '../../Action/Index';
import {Spinner} from 'react-bootstrap';
import queryString from 'query-string';

class ResetPasswordOne extends Component {
    state = {
        type: 'password',
        confirmType: 'password',
        secondWindow: false,
        passwordMisMatch: false,
        token:'',
        email:'',
        resetmsg:'',
        show:false,
        id:''
    }

    componentWillMount=()=>{
        let url=this.props.location.search;
        if(localStorage.getItem('userToken')!=null && localStorage.getItem('userToken')!="" && localStorage.getItem('userToken')!=undefined){
            this.props.history.push('/interview')
          }
        else{
            
         if(url!==''){
            let params = queryString.parse(url);
           let tokn=params.token
           let emailExtract=tokn.split('$');
           this.setState({token:tokn,email:emailExtract[1],id:emailExtract[2]})
        }
        else{
            this.backToLogin();
        }
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.errorMsg!==""){
            this.setState ({resetmsg:nextProps.errorMsg,show:true});
        }
    }
    passwordChangedHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
     
        let email=this.state.email; 
        if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/.test(e.target.password.value)) {
            this.setState({
                passwordErrMsg: "Password should be between 8-15 characters with atleast one upper case,lower case,one digit and one special character."
            })
        }
       else{
       if(e.target.password.value === e.target.confirmPassword.value){
        this.setState({
            passwordMisMatch: false,
            resetmsg:"",
            show:false,
        })
        // if(this.state.id==='CN'){
        // this.props.onReset(email,e.target.password.value,this.state.token);
        // }
        // else{
           this.props.updatingNewPassword(e.target.password.value, e.target.confirmPassword.value,this.state.token)
        // }
    } 
    else{
       this.setState({
           passwordMisMatch: true,
           resetmsg:"",
           show:true,
       })
    }
    }
}

    passwordFormatChangedHandler = () => {
        if (this.state.type === 'password') {
            this.setState({
                type: 'text'
            })

            document.getElementById('password').classList.add("fa-eye");
            document.getElementById('password').classList.remove("fa-eye-slash");
        }
        else {
            this.setState({
                type: 'password'
            })
            document.getElementById('password').classList.remove("fa-eye");
            document.getElementById('password').classList.add("fa-eye-slash");
        }
    }

    confirmPasswordFormatChangedHandler = () => {
        if (this.state.confirmType === 'password') {
            this.setState({
                confirmType: 'text'
            })

            document.getElementById('confirm_password').classList.add("fa-eye");
            document.getElementById('confirm_password').classList.remove("fa-eye-slash");
        }
        else {
            this.setState({
                confirmType: 'password'
            })
            document.getElementById('confirm_password').classList.remove("fa-eye");
            document.getElementById('confirm_password').classList.add("fa-eye-slash");
        }
    }
      
     backToLogin=()=>{
        this.props.history.push({
            pathname:'/login'
           });
     }

     setShow() {
        this.setState({
            show: false,
        })
    }

     passwordLength = (e, len2) =>
    {
        if (e.target.value.length >= len2 && e.which !== 8 )
        {
            e.preventDefault();
           
        }
      
    }

    render() {
       
        return (
            this.props.resetStatus ? <ResetPasswordSuccess {...this.props} role={this.state.id}/> :
                <div className={classes.Background}>
                    <Container style={{ padding: '12%' }} fluid>
                        <Row className="justify-content-center ">
                            <Col md={7}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className={`text-center ${classes.Title}`}>Reset Password</Card.Title>
                                        {this.state.show ?
                                            <div>
                                        <div className={classes.alerMainBox}>
                                            <div className={classes.alert}>
                                                <p className={classes.closebtn} onClick={() => this.setShow()} >&times;</p>
                                            </div>
                                            <div className={classes.messageBox}>

                                            <span className={classes.passwordMismatch}> &nbsp; {this.state.passwordMisMatch ? 'Passwords did not match' : null }</span>
                                            <span className={classes.expireMsg}> {this.state.resetmsg}</span>
                                            </div>
                                          
                                        </div>
                                        <br/>
                                        </div>
                                        : null}
                                        <Card.Text>
                                            <Form onSubmit={(e) => this.passwordChangedHandler(e)}>
                                                <Form.Group className={` mb-4 ${classes.formGroup}`}>
                                                    <label className="has-float-label">
                                                        <input type={this.state.type} id="_password" placeholder=" " required
                                                             style={{marginBottom: 'auto'}}
                                                            autoComplete="off" name="password" 
                                                            onInput={() => this.setState({passwordErrMsg: ""})}
                                                            onKeyDown={(e)=>this.passwordLength(e,15)}
                                                        />
                                                        <span>New Password</span>
                                                    </label>
                                                   
                                                    <span toggle="#password-field" className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                                                        id="password" onClick={this.passwordFormatChangedHandler}></span>
                                                         <span className = {classes.PasswordValidation}>{this.state.passwordErrMsg}</span>
                                                </Form.Group>
                                                <Form.Group className={` ${classes.formGroup}`}>
                                                    <label className="has-float-label">
                                                        <input type={this.state.confirmType} id="_confirmpassword" placeholder=" " required
                                                         style={{marginBottom: 'auto'}}
                                                            autoComplete="off" name="confirmPassword" 
                                                            onInput= {() => this.setState({passwordErrMsg: ""})}
                                                            onKeyDown={(e)=>this.passwordLength(e,15)}
                                                        />
                                                        <span>Confirm Password</span>
                                                    </label>
                                                    <span toggle="#password-field" className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                                                        id="confirm_password" onClick={this.confirmPasswordFormatChangedHandler}>
                                                    </span>
                                                  
                                                </Form.Group>
                                                
                                                <Row>
                                           <Col lg={4} md={12} sm={12}> <span className={classes.spinner}>{this.props.loader?<Spinner animation="border" variant="warning" />:null}</span>
                                           </Col>   
                                          {this.state.id=="CN"?
                                           <Col lg={4} md={6} sm={6}><Button variant="outline-warning" onClick={()=>this.backToLogin()}
                                            className={classes.Button1}  disabled={this.props.loader}>Back to Login</Button>
                                            </Col>
                                             :null}

                                           <Col lg={4} md={6} sm={6}><Button variant="warning text-white" className={classes.Button2}
                                                        type="submit" disabled={this.props.loader}>Reset Password</Button></Col>
                                                </Row>
                                            </Form>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
        );
    }
}

const mapStateToProps = state => {
    return{
      resetStatus: state.employeeReducer.resetPassword,
      loader: state.employeeReducer.resetLoader,
      errorMsg:state.employeeReducer.resetErrorMsg
      
    }
  }
  
const mapDispatchToProps = dispatch => {
    return{
      onReset: (email,pass,token) => dispatch(actionTypes.getResetPassword(email,pass,token)),
      updatingNewPassword:(pass,confirm,token)=>dispatch(actionTypes.updatingNewPassword(pass,confirm,token))
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(ResetPasswordOne);